<template>
    <div class="layout">
        <div class="row">
            <div class="col-xs-12">
                <input accept="image/*" class="mt-2" type="file" multiple name="fotos" id="fotos">
                <button type="button" @click="subir" class="btn-success"><i class="fa fa-upload"></i><span>Subir fotos</span></button>
            </div>
        </div>
        <div class="row">
            <div :key="index" v-for="(foto, index) in fotos" class="col-xs-12 col-md-3">
                <button type="button" @click="eliminarFoto(index)" class="btn-danger btn--text"><i class="fa fa-times"></i></button>
                <a download :href="url + '/storage/' + foto.path_foto">
                    <img height="150px" width="100%" :src="url + '/storage/' + foto.path_foto" alt="Foto">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        clienteId: {
            type: String,
            required: false,
            default: ''
        },
        fotos: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            url: url
        };
    },
    methods: {
        eliminarFoto: function (index) {
            swal({
                title: "¿Desea eliminar la foto seleccionada?",
                text: "Se requiere confirmación",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    axios.post(url + '/clientes/fotos/' + this.fotos[index].id, {
                        _method: 'DELETE'
                    }).then(() => {
                        this.fotos.splice(index, 1);
                        swal.fire('La foto seleccionada ha sido anulada.', 'Aviso', 'success');
                    }).catch(() => {
                        swal.fire('Hubo un error, intente nuevamente.', 'Error', 'error');
                    });
                }
            });   
        },
        subir: function () {
            let formData = new FormData();
            let files = document.getElementById('fotos').files;
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    formData.append('fotos[]', files[i]);
                }
                axios.post(url + '/clientes/fotos/' + this.clienteId, formData).then(() => {
                    swal.fire('Las fotos han sido subidas exitósamente.', 'Realizado', 'success');
                    this.$emit('fotosGuardadas');
                }).catch(() => {
                    swal.fire('Hubo un error');
                });
            }
            else 
                swal.fire('Debe seleccionar al menos una foto.', 'Aviso', 'warning');
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/clientes/FotosClientes.vue